<button
  mat-icon-button
  [matMenuTriggerFor]="languageMenu"
  class="language-selector-trigger"
  [disabled]="saving()"
  [attr.aria-label]="'layout.languageSelector' | transloco"
>
  <img
    class="language-selector-flag"
    [src]="currentLanguage() === 'ro' ? '/images/flags/ro.png' : '/images/flags/en.png'"
    alt=""
  />
</button>

<mat-menu #languageMenu="matMenu">
  <button mat-menu-item (click)="selectLanguage('en')">
    <img class="language-selector-flag me-1" src="/images/flags/en.png" alt="" />
    <span>{{ 'language.english' | transloco }}</span>
  </button>
  <button mat-menu-item (click)="selectLanguage('ro')">
    <img class="language-selector-flag me-1" src="/images/flags/ro.png" alt="" />
    <span>{{ 'language.romanian' | transloco }}</span>
  </button>
</mat-menu>
